module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-700.9af0daf.woff2";